import React, { Component } from 'react';
import { Switch, Route, Router } from 'react-router-dom';
import { history } from '../store';
import ModulePartners from '../Containers/Partners';
import ModuleNewPartners from '../Containers/Partners/PartnersNew';
import dashboard from '../Containers/Dashboard';
import moduleInfo from '../Containers/Info';
import ModuleMenu from '../Containers/Menu';
import moduleSettings from '../Containers/Settings';
import quatreCentQuatre from '../Components/404';
import GlobalPartner from '../Containers/Partners/Containers/index';
import config from '../config';
import MaintenanceGuard from '../Components/MaintenanceGuard';

export const validPaths = [
	'',
	'info',
	'partners',
	'menu',
	'settings',
	'redirect',
]; // mettre a jour ici si on rajoute une route

export default class route extends Component {
	render() {
		const { hasGroupEspaceClient } = this.props;
		const espaceClientUrl = config.ESPACE_CLIENT_URL;

		return (
			<Router history={history}>
				<Switch>
					<Route exact path={'/'} component={dashboard} />
					{/* <Route
						exact
						path={'/partners'}
						render={() => (
							<MaintenanceGuard>
								<ModulePartners />
							</MaintenanceGuard>
						)}
					/> */}
					<Route
						exact
						path={'/partners'}
						render={() => (
							<MaintenanceGuard>
								<ModuleNewPartners />
							</MaintenanceGuard>
						)}
					/>
					<Route exact path={'/settings'} component={moduleSettings} />
					<Route exact path={'/info'} component={moduleInfo} />
					<Route
						exact
						path={'/menu'}
						render={() => {
							if (hasGroupEspaceClient) {
								window.location.href = `${espaceClientUrl}menu`;
								return null;
							}

							return <ModuleMenu />;
						}}
					/>
					<Route path={'/redirect'} component={''} />
					<Route
						path={'/partners/:prefix'}
						render={props => (
							<MaintenanceGuard>
								<GlobalPartner {...props} />
							</MaintenanceGuard>
						)}
					/>

					<Route component={quatreCentQuatre} />
				</Switch>
			</Router>
		);
	}
}
